import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import News from '../views/News.vue'
import New from '../views/New.vue'
import Product from '../views/Product.vue'
import Boxs from '../views/Boxs.vue'
import Box from '../views/Box.vue'
import Touch from '../views/Touch.vue'
import Recruits from '../views/Recruits.vue'
import Docs from '../views/Docs.vue'
import Doc from '../views/Doc.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import i18n, { LOCALE_ZH, LOCALE_EN } from '../locales'
import { localePath, getStoredLocale } from '../utils/locale'
import { detectCountryCode } from '../utils/geo'

// 基础路由配置（唯一事实来源，path 不带语言前缀）
// 每条路由的 meta.titleKey 对应语言包 routes 命名空间，用于生成 document.title
const baseRoutes = [
  // 首页路由
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { titleKey: 'routes.home' }
  },
  // 关于我们路由
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { titleKey: 'routes.about' }
  },
  // 关于我们子页面路由
  {
    path: '/about/history',
    name: 'history',
    component: () => import('../views/about/History.vue'),
    meta: { titleKey: 'routes.history' }
  },
  {
    path: '/about/team',
    name: 'team',
    component: () => import('../views/about/Team.vue'),
    meta: { titleKey: 'routes.team' }
  },
  {
    path: '/about/organization',
    name: 'organization',
    component: () => import('../views/about/Organization.vue'),
    meta: { titleKey: 'routes.organization' }
  },
  {
    path: '/about/honors',
    name: 'honors',
    component: () => import('../views/about/Honors.vue'),
    meta: { titleKey: 'routes.honors' }
  },
  // 新闻模块路由(健康咨询)
  {
    path: '/news',
    name: 'news',
    component: News,
    meta: { titleKey: 'routes.news' }
  },
  {
    path: '/news/:id',
    name: 'new',
    component: New,
    meta: { titleKey: 'routes.new' }
  },
  // 新闻子页面
  {
    path: '/news/media',
    name: 'media',
    component: () => import('../views/news/Media.vue'),
    meta: { titleKey: 'routes.media' }
  },
  {
    path: '/news/video',
    name: 'newsVideo',
    component: () => import('../views/news/Video.vue'),
    meta: { titleKey: 'routes.newsVideo' }
  },
  // 联系模块路由(联系我们)
  {
    path: '/touch',
    name: 'touch',
    component: Touch,
    meta: { titleKey: 'routes.touch' }
  },
  // 包厢模块路由
  {
    path: '/boxs',
    name: 'boxs',
    component: Boxs,
    meta: { titleKey: 'routes.boxs' }
  },
  {
    path: '/boxs/:id',
    name: 'box',
    component: Box,
    meta: { titleKey: 'routes.box' }
  },
  // 业务子页面
  {
    path: '/boxs/services',
    name: 'services',
    component: () => import('../views/boxs/Services.vue'),
    meta: { titleKey: 'routes.services' }
  },
  {
    path: '/boxs/services/:id',
    name: 'serviceDetail',
    component: () => import('../views/boxs/ServiceDetail.vue'),
    meta: { titleKey: 'routes.serviceDetail' }
  },
  {
    path: '/boxs/projects',
    name: 'projects',
    component: () => import('../views/boxs/Projects.vue'),
    meta: { titleKey: 'routes.projects' }
  },
  // 招聘模块路由(加入我们)
  {
    path: '/recruits',
    name: 'recruits',
    component: Recruits,
    meta: { titleKey: 'routes.recruits' }
  },
  // 招聘子页面
  {
    path: '/recruits/campus',
    name: 'campus',
    component: () => import('../views/recruits/Campus.vue'),
    meta: { titleKey: 'routes.campus' }
  },
  {
    path: '/recruits/social',
    name: 'social',
    component: () => import('../views/recruits/Social.vue'),
    meta: { titleKey: 'routes.social' }
  },
  {
    path: '/recruits/intern',
    name: 'intern',
    component: () => import('../views/recruits/Intern.vue'),
    meta: { titleKey: 'routes.intern' }
  },
  {
    path: '/recruits/jobs/:id',
    name: 'jobCategoryDetail',
    component: () => import('../views/recruits/JobCategoryDetail.vue'),
    meta: { titleKey: 'routes.jobCategoryDetail' }
  },
  // 产品模块路由
  {
    path: '/product',
    name: 'product',
    component: Product,
    meta: { titleKey: 'routes.product' }
  },
  // 企业文化子页面
  {
    path: '/product/social',
    name: 'socialResp',
    component: () => import('../views/product/Social.vue'),
    meta: { titleKey: 'routes.socialResp' }
  },
  {
    path: '/product/social/:id',
    name: 'socialRespDetail',
    component: () => import('../views/product/SocialDetail.vue'),
    meta: { titleKey: 'routes.socialRespDetail' }
  },
  {
    path: '/product/innovation',
    name: 'innovation',
    component: () => import('../views/product/Innovation.vue'),
    meta: { titleKey: 'routes.innovation' }
  },
  {
    path: '/product/innovation/:id',
    name: 'innovationDetail',
    component: () => import('../views/product/InnovationDetail.vue'),
    meta: { titleKey: 'routes.innovationDetail' }
  },
  // 文档模块路由
  {
    path: '/docs',
    name: 'docs',
    component: Docs,
    meta: { titleKey: 'routes.docs' }
  },
  {
    path: '/docs/:id',
    name: 'doc',
    component: Doc,
    meta: { titleKey: 'routes.doc' }
  },
  // 法律页面
  {
    path: '/legal/privacy',
    name: 'privacy',
    component: () => import('../views/legal/Privacy.vue'),
    meta: { titleKey: 'routes.privacy' }
  },
  {
    path: '/legal/terms',
    name: 'terms',
    component: () => import('../views/legal/Terms.vue'),
    meta: { titleKey: 'routes.terms' }
  },
  // 网站地图
  {
    path: '/sitemap',
    name: 'sitemap',
    component: () => import('../views/Sitemap.vue'),
    meta: { titleKey: 'routes.sitemap' }
  },
  // 搜索页面
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/Search.vue'),
    meta: { titleKey: 'routes.search' }
  }
]

// 工厂：为一份基础路由加语言前缀。
// 英文路由名统一加 en- 前缀防止碰撞（代码库中无按名跳转，重命名零风险）
function localizeRoutes(prefix, locale) {
  return baseRoutes.map(r => ({
    ...r,
    path: r.path === '/' ? (prefix || '/') : `${prefix}${r.path}`,
    name: prefix ? `en-${r.name}` : r.name,
    meta: { locale, ...r.meta }
  }))
}

// 404 页：中英文各一个 catch-all，必须放在路由表最后
const notFound = (prefix, locale) => ({
  path: `${prefix}/:pathMatch(.*)*`.replace('//', '/'),
  name: `${prefix ? 'en-' : ''}notFound`,
  component: () => import('../views/NotFound.vue'),
  meta: { locale, titleKey: 'routes.notFound' }
})

const routes = [
  ...localizeRoutes('', LOCALE_ZH),      // 中文：保持现有路径
  ...localizeRoutes('/en', LOCALE_EN),   // 英文：/en、/en/about、/en/news/:id ...
  notFound('', LOCALE_ZH),
  notFound('/en', LOCALE_EN)
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 新页面从顶部开始；浏览器前进/后退时还原 savedPosition
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  }
})

// 钩子函数实现加载功能
// 前置钩子：NProgress + 语言始终跟随 URL
// 首次直接打开站点落在中文页时决定默认语言，优先级：存储偏好 > IP 归属 > 默认中文
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.meta.locale) {
    i18n.global.locale.value = to.meta.locale
  }
  if (from === START_LOCATION && to.meta.locale === LOCALE_ZH) {
    // 用户明确选择过英文 → 跳对应英文页（保留 query）
    if (getStoredLocale() === LOCALE_EN) {
      return next({ path: localePath(to.path, LOCALE_EN), query: to.query })
    }
    // 无存储偏好 → 按 IP 归属：非中国大陆默认英文版
    // 查询带 2 秒超时且整会话缓存；失败返回 null，保持中文默认
    const country = await detectCountryCode()
    if (country && country !== 'CN') {
      return next({ path: localePath(to.path, LOCALE_EN), query: to.query })
    }
  }
  next()
})
// 后置钩子：完成进度条 + 按语言设置标题与 <html lang>
router.afterEach((to) => {
  NProgress.done();
  const t = i18n.global.t
  document.title = to.meta.titleKey === 'routes.home'
    ? t('common.siteName')
    : `${t(to.meta.titleKey)} | ${t('common.siteName')}`
  document.documentElement.lang = to.meta.locale === LOCALE_EN ? 'en' : 'zh-CN'
})

export default router
